<template>
  <div class="card card-custom gutter-b example example-compact">
    <div class="card-header">
      <div class="card-title">
        <router-link to="/admin/blog-categories" class="mr-5">
          <b-icon icon="arrow-left" scale="1.5"></b-icon>
        </router-link>
        <h3>News-Kategorie hinzufügen</h3>
      </div>
    </div>
    <div class="card-body">
      <div class="listing-form-main">
        <ValidationObserver ref="newCategoryForm">
          <b-form class="form" @submit.stop.prevent="onSubmit">
            <div class="row">
              <div class="col-md-6 form-div">
                <b-form-group>
                  <ValidationProvider
                    rules="required"
                    v-slot="{ errors }"
                    :custom-messages="{
                      required: 'Der Kategorie-Name ist erforderlich',
                    }"
                  >
                    <v-text-field
                      :error-messages="errors[0]"
                      autocomplete="new-password"
                      v-model="form.categoryName"
                      label="Kategorie-Name"
                      outlined
                    ></v-text-field>
                  </ValidationProvider>
                </b-form-group>
                <v-divider></v-divider>
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <v-text-field
                        autocomplete="new-password"
                        v-model="form.blogMetaTitle"
                        label="Beitrags-Kategorie Meta Name"
                        outlined
                      ></v-text-field>
                    </b-form-group>
                  </div>
                </div>
                <div class="row">
                  <div class="col-md-12">
                    <b-form-group id="fieldset-horizontal">
                      <v-text-field
                        autocomplete="new-password"
                        v-model="form.blogMetaDescription"
                        label="Beitrags-Kategorie Meta Beschreibung"
                        outlined
                      ></v-text-field> 
                    </b-form-group>
                  </div>
                </div>
                <!-- <v-divider></v-divider> -->
                <div class="row">
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <!-- <ValidationProvider
                      :rules="{
                          required: false,
                          regex:/^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm
                       }"
                       
                        v-slot="{ errors }"
                        :custom-messages="{
                          regex: 'Das Linkformat ist falsch. Bitte korrekten Link eingeben',
                        }"
                      > -->
                      <v-text-field
                        autocomplete="new-password"
                        v-model="form.blogCanonicalLink"
                        label="Beitrags-Kategorie Canonical Link"
                        outlined
                      ></v-text-field>
                      <!-- </ValidationProvider> -->
                    </b-form-group>
                  </div>
                  <div class="col-md-6">
                    <b-form-group id="fieldset-horizontal">
                      <v-select
                          autocomplete="new-password"
                          :items="robotValues"
                          v-model="form.blogMetaRobots"
                          item-text="lable"
                          item-value="value"
                          label="Beitrags-Kategorie Meta Robots"
                          outlined clearable
                        />
                    </b-form-group>
                  </div>
                </div>
                <v-divider></v-divider>  

                <b-form-group>
                  <v-switch
                    v-model="showOnHome"
                    inset
                    :label="showOnHome == true ? 'Auf der Startseite anzeigen' : 'Nicht auf der Startseite anzeigen'"
                    class="d-inline-block"
                  ></v-switch>
                </b-form-group>

                <b-form-group>
                  <v-switch
                    v-model="status"
                    inset
                    :label="status == true ? 'Aktiviert' : 'Deaktiviert'"
                    class="d-inline-block"
                  ></v-switch>
                </b-form-group>

                <div class="fo-row-btn text-right">
                  <v-btn
                    class="submit-btn-fill-outline"
                    @click="goToBack"
                  >
                    Abbrechen
                  </v-btn>
                  <v-btn
                    type="submit"
                    :disabled="isDisabled"
                    ref="kt_form_submit_btn"
                    class="submit-btn-fill-color"
                  >
                    {{ submitText }}
                  </v-btn>
                </div>
              </div>
            </div>
          </b-form>
        </ValidationObserver>
      </div>
    </div>
    <notifications group="categories" position="bottom right" />
  </div>
</template>

<script>
import Vue from "vue";
import { mapGetters } from "vuex";
import axios from "axios";
import Notifications from "vue-notification";
import JwtService from "@/core/services/jwt.service";
import vue2Dropzone from "vue2-dropzone";
import "vue2-dropzone/dist/vue2Dropzone.min.css";
import adminAPI from "@/api/admin";
import metarobots from "@/config/constant";

Vue.use(Notifications);
export default {
  name: "AddBlogCategory",
  created() {
    if (!this.isAuthenticated) {
      this.$router.push({ name: "Login" });
    } else {
      this.userId = localStorage.getItem("local_products_user_access_id");
      this.robotValues = metarobots;
    }
  },
  data() {
    return {
      formError: false,
      userId: null,
      formData: [],
      btnDisable: false,
      submitText: "Speichern",
      status: true,
      showOnHome: false,
      robotValues: [],
      form: {
        // categoryImage: null,
        categoryName: null,
        blogMetaTitle: null,
        blogMetaDescription: null,
        blogCanonicalLink: null,
        blogMetaRobots: null,
        // categoryDescription: null,
      },
    };
  },
  methods: {
    goToBack() {
      this.$router.push({ name: "blog-categories" });
    },
    onSubmit() {
      this.$refs.newCategoryForm.validate().then((success) => {
        if (success) {
          this.btnDisable = true;
          this.submitText = "Wird gespeichert...";
          let fd = new FormData();
          fd.append("name", this.form.categoryName);
          fd.append("status", this.status == true ? "1" : "0");
          fd.append("show_on_home", this.showOnHome == true ? "1" : "0");
          fd.append("meta_title", this.form.blogMetaTitle ? this.form.blogMetaTitle : "");
          fd.append("meta_description", this.form.blogMetaDescription ? this.form.blogMetaDescription : "");
          fd.append("canonical_link", this.form.blogCanonicalLink ? this.form.blogCanonicalLink : "");
          fd.append("meta_robot", this.form.blogMetaRobots ? this.form.blogMetaRobots : "");
          setTimeout(() => {
            adminAPI
              .addBlogCategory(fd)
              .then((response) => {
                if (response.status == "success") {
                  this.submitText = "Speichern"
                  this.btnDisable = false;
                  this.$notify({
                    group: "categories",
                    type: "success",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                  setTimeout(() => {
                    this.$router.push({ name: "blog-categories" });
                  }, 2000);
                } else {
                  this.btnDisable = false;
                  this.submitText = "Speichern";

                  this.$notify({
                    group: "categories",
                    type: "error",
                    position: "bottom right",
                    text: response.msg,
                    duration: 5000,
                  });
                }
              })
              .catch((err) => {
                this.btnDisable = false;
                this.submitText = "Speichern";
                this.$notify({
                  group: "categories",
                  type: "error",
                  position: "bottom right",
                  text: err,
                  duration: 5000,
                });
              });
          }, 2000);
        } else {
          this.formError = true;
          this.btnDisable = false;
          this.submitText = "Speichern";
        }
      });
    },
  },
  computed: {
    ...mapGetters(["isAuthenticated"]),
    isDisabled: function () {
      return this.btnDisable;
    },
  },
};
</script>

<style scoped>
h3 {
  font-family: "ubuntu";
  color: #000;
}

.form-div {
  margin: auto;
}

.form-errors {
  color: red;
}

.submit-button {
  background-color: #3d5a80 !important;
}

.submit-button:hover {
  background-color: #002c47 !important;
}

.spinner.spinner-right {
  padding-right: 3.5rem !important;
}
</style>
